class EncodeSearchTerm {
  static searchTermEncode(text) {
    return encodeURIComponent(text);
  }
}
export default EncodeSearchTerm;
